<div class="grid">
    <div class="col-12">
        <div class="card">
            <div class="row">
                <button
                    pButton
                    pRipple
                    routerLink="/rfarias/empresa/inserir"
                    label="Novo"
                    icon="pi pi-plus"
                    class="p-button-info mr-2 mb-4"
                ></button>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="itensPaginados.content"
                dataKey="id"
                [rows]="tamanhoPagina"
                [rowsPerPageOptions]="[1, 2, 3, 4, 5, 10]"
                [loading]="loading"
                [rowHover]="true"
                [paginator]="true"
                [totalRecords]="itensPaginados.totalElements"
                [lazy]="true"
                [showCurrentPageReport]="true"
                (onLazyLoad)="onLazyLoad($event)"
                responsiveLayout="scroll"
                styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div></div>
                        <div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input
                                    pInputText
                                    type="text"
                                    #filter
                                    (input)="buscar($event)"
                                    placeholder="Buscar"
                                    class="w-full"
                                />
                            </span>
                            <span class="ml-2">
                                <button
                                    pButton
                                    class="p-button-outlined"
                                    icon="pi pi-filter-slash"
                                    pTooltip="Limpar Filtros"
                                    (click)="limpar(dt1)"
                                ></button>
                            </span>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nomeFantasia">
                            Nome
                            <p-sortIcon field="nomeFantasia"></p-sortIcon>
                        </th>
                        <th pSortableColumn="cidade">
                            Cidade
                            <p-sortIcon field="cidade"></p-sortIcon>
                        </th>
                        <th pSortableColumn="uf">
                            UF
                            <p-sortIcon field="uf"></p-sortIcon>
                        </th>
                        <th>
                            <div>Ações</div>
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.nomeFantasia }}
                        </td>
                        <td>
                            {{ item.cidade }}
                        </td>
                        <td>
                            {{ item.uf }}
                        </td>
                        <td>
                            <button
                                pButton
                                pRipple
                                pTooltip="Detalhar"
                                (click)="detalhar(item.id)"
                                icon="pi pi-eye"
                                class="p-button-info mr-2 mb-2"
                            ></button>
                            <button
                                pButton
                                pRipple
                                pTooltip="Editar"
                                (click)="editar(item.id)"
                                icon="pi pi-pencil"
                                class="p-button-success mr-2 mb-2"
                            ></button>
                            <button
                                pButton
                                pRipple
                                pTooltip="Excluir"
                                icon="pi pi-trash"
                                class="p-button-danger mr-2 mb-2 sm"
                            ></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando grupos. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
